import { Type } from "@angular/core";
import { OutstandingInvoicesChartComponent, VendorHistoryChartComponent } from "./charts";

export * from "./provider";
export * from "./charts";
export * from "./interfaces";

export
{
    BankCodeService,
    /** @deprecated use `BankCodeService` instead */
    BankCodeService as IBankCodeLookup,
    CheckStockService,
    /** @deprecated use `CheckStockService` instead */
    CheckStockService as ICheckStockExtendedLookupService,
    CommodityCodeService,
    VendorAddressService,
    ApModuleControlService,
    ContractService,
    FundTotalService,
    GroupCodeLookupService,
    InvoiceService,
    PayableService,
    PaymentPrintBatchService,
    PaymentService,
    PurchaseCardService,
    SalesTaxCodeLookupService,
    ShipToLookupService,
    VendorClassLookupService,
    VendorContactService,
    VendorDirectDepositService,
    VendorInvoiceEntryService,
    VendorLookupService,
    VendorMergeService,
    VendorService,
    VendorSetLookupService,
    VendorTemplateLookupService,
} from "./services";

export const AP_CHART_COMPONENTS: Record<string, Type<unknown>> = {
    "AccountsPayable.OutstandingInvoicesChart": OutstandingInvoicesChartComponent,
    "AccountsPayable.VendorHistoryChart": VendorHistoryChartComponent,
};
